import { useState } from "react";
import { postMethod } from "../../../../function/helper";
import Swal from "sweetalert2";
import { Button, Form, Modal } from "react-bootstrap";

function AgentFormModal({ close, phone, nationalCode }) {
  const [code, setCode] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const sendCode = async () => {
    setIsLoading(true);
    const body = { phone, code, nationalCode };
    const response = await postMethod("/user/v1/code", body);
    setIsLoading(false);

    if (response.status === 200) {
      window.localStorage.clear();
      window.sessionStorage.clear();
      localStorage.setItem("token", response.data.data);
      window.location.replace("/");
    } else {
      Swal.fire({
        icon: "error",
        text: response.data.data,
        showConfirmButton: true,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "red",
      });
    }
  };

  return (
    <Modal show={true} dir="rtl">
      <Modal.Header>
        <Modal.Title className="text-center">
          ثبت نام با موفقیت انجام شد
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Label>لطفا کد ارسالی را وارد کنید</Form.Label>
        <Form.Control type="text" onChange={e => setCode(e.target.value)} />
      </Modal.Body>
      <Modal.Footer>
        {isLoading === true ? (
          <Button variant="primary"></Button>
        ) : (
          <Button variant="primary" onClick={sendCode}>
            ارسال
          </Button>
        )}

        <Button variant="secondary" onClick={close}>
          بستن و ویرایش شماره
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AgentFormModal;
